import { createAction, props } from "@ngrx/store";
import { RankListResponseWrapper } from "src/app/api/models";

export enum BranchChampionsActionTypes {
    LOAD_BRANCHCHAMPIONS = '[BranchChampions] load many',
    LOAD_BRANCHCHAMPIONS_FAIL = '[BranchChampions] load many fail',
    LOAD_BRANCHCHAMPIONS_SUCCESS = '[BranchChampions] load many success',
}

export const loadMany = createAction(BranchChampionsActionTypes.LOAD_BRANCHCHAMPIONS, props<{ month: string, nameSpace: string }>());
export const loadManyFail = createAction(BranchChampionsActionTypes.LOAD_BRANCHCHAMPIONS_FAIL, props<{ error: object }>());
export const loadManySuccess = createAction(BranchChampionsActionTypes.LOAD_BRANCHCHAMPIONS_SUCCESS, props<{ items: RankListResponseWrapper[] }>());